import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  IconButton,
  TableHead,
} from '@mui/material';
import { ICopperPipingRequest } from '../../../utils/entities/interface';
import { capitalizeWords, formatBookingSlot } from '../../../utils/helper';
import { ListTable } from '../../molecules/ListTable';
import { SkeletonRows } from '../../skeletons/list';
import { RemoveRedEyeOutlined } from '@mui/icons-material';

export const CopperPipingRequests = ({
  requests,
  isLoading,
  onUpdate,
  tableCell,
  onManageClick,
}: {
  requests: any[];
  isLoading: boolean;
  onUpdate: () => void;
  tableCell?: any[];
  onManageClick: (id: string) => void;
}) => {
  const actions = [
    {
      icon: <RemoveRedEyeOutlined />,
      onClick: (row: any) => onManageClick(row._id),
    },
  ];

  return (
    <>
      <ListTable
        headerCells={tableCell?.map((cell) => cell) || []}
        rows={requests}
        isLoading={isLoading}
        actions={actions}
        renderCell={(request: ICopperPipingRequest, colIndex: number) => {
          switch (colIndex) {
            case 0:
              return request?.enquiryId || '-';

            case 1:
              return capitalizeWords(request?.user?.name) || 'N/A';

            case 2:
              return 'Copper Pipe';

            case 3:
              return capitalizeWords(request?.technicianName) || 'N/A';

            case 4:
              return `+91-${request?.user?.phoneNumber?.slice(0, 10)}`;

            case 5:
              return formatBookingSlot(
                request?.schedule?.date,
                request?.schedule?.slot,
              );

            case 6:
              return capitalizeWords(request?.status) || 'N/A';

            default:
              return null;
          }
        }}
      />
    </>
  );
};
